import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const StyleUserDetailWrapper = styled.div<{ isUser?: boolean }>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
  row-gap: 12px;
  align-items: ${(props: any) => (props.isUser ? 'start' : 'stretch')};
  & > :nth-of-type(1) {
    grid-row: span 2;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    & > :nth-of-type(1) {
      grid-column: span 2;
    }
  }
  @media (max-width: 640px) {
    grid-template-columns: repeat(1, 1fr);
    & > :nth-of-type(1) {
      grid-column: span 1;
      grid-row: auto;
    }
  }
`

const sharedCardStyle = (props: any) => css`
  box-shadow: ${props.theme.colors.boxShadow};
  border-radius: 12px;
  padding: 14px;
  background-color: ${props.theme.colors.white};
  color: ${props.theme.colors.text};
`

export const StyleStatsCard = styled.div`
  ${sharedCardStyle}
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  align-items: flex-start;
  min-height: 75px;
`

export const StyleStatsCardTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
`
export const StyleStatsCardTitle = styled.p`
  letter-spacing: 0.25px;
  line-height: 20px;
  font-size: 14px;
`
export const StyleStatsCardNumber = styled.p`
  font-size: 18px;
  line-height: 20px;
`
export const translateSvg = ` 
  transform:translateY(1px)
`

export const StyleProfileWrapper = styled.div`
  ${sharedCardStyle}
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  align-items: flex-start;
  justify-content: space-around;
`
export const PersonalInfo = styled.div`
  display: flex;
  column-gap: 12px;
  align-items: center;
`
export const Profile = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 100vh;
  background-color: yellow;
`
export const Details = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  align-items: flex-start;
`

export const Name = styled.p`
  font-size: 16px;
`
export const Number = styled.p`
  font-size: 14px;
`
export const Email = styled.p`
  font-size: 14px;
`
export const ActionButton = styled.button`
  width: 100%;
  padding: 8px;
  background-color: transparent;
  outline: none;
  border: 2px solid ${(props: any) => props.theme.colors.primary};
  border-radius: 8px;
  border-width: 1.5px;
  color: ${(props: any) => props.theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  font-size: 14px;
  letter-spacing: 0.75px;
  transition: all 300ms ease-in;
  &:hover {
    svg {
      stroke: white;
    }
    color: ${(props: any) => props.theme.colors.white};
    background-color: ${(props: any) => props.theme.colors.primary};
  }
`
export const ProfileFallback = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 20px;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  background-color: #b2bec3;
  color: #ffffff;
  border-radius: 100%;
`
export const ProfileWrapper = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dfe6e9;
  font-size: 24px;
  font-weight: 600;
  color: #2d3436;
`

export const Circle = styled.div<{ size?: number }>`
  width: ${({ size }) => (size ? `${size}px` : '40px')};
  height: ${({ size }) => (size ? `${size}px` : '40px')};
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  font-size: ${({ size }) => (size ? `${size / 2}px` : '18px')};
  color: #333;
`
